import React, { useEffect } from "react";

export default function LogoutConfirmModal({ open, onClose, onConfirm }) {
  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
      if (e.key === "Enter") onConfirm?.();
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose, onConfirm]);

  if (!open) return null;

  return (
    <div className="ac-modal-backdrop" role="dialog" aria-modal="true">
      <div className="ac-modal">
        <div className="ac-modal-title">Abmelden?</div>
        <div className="ac-modal-text">
          Willst du dich wirklich ausloggen? Du musst dich danach wieder neu anmelden.
        </div>

        <div className="ac-modal-actions">
          <button onClick={onClose} className="ac-ghostbtn">
            Abbrechen
          </button>
          <button onClick={onConfirm} className="ac-primarybtn">
            Ja, ausloggen
          </button>
        </div>
      </div>
    </div>
  );
}